const ThemeEnum = {
  MICROF: { value: 'microf' },
  RHEEM: { value: 'rheem' },
  OPTIMUS: { value: 'optimus' },
};

export default ThemeEnum;
